import React from "react";
import { Row, Col } from "react-bootstrap";
import { Icon } from "semantic-ui-react";

const formatAmount = (value) => {
  if (value == null) return "-";
  const num = parseFloat(value);
  return num < 1000 ? `$${num.toFixed(2)}M` : `$${(num / 1000).toFixed(2)}B`;
};

const ClimateRiskKPICards = ({
  data,
  handleCardFindings_1,
  handleCardFindings_3,
  handleCardFindings_5,
  handleCardFindings_6,
}) => {
  const { climate_risk_card_data = {} } = data;

  const avoidedLoss =
    (climate_risk_card_data.climate_value_at_risk || 0) -
    (climate_risk_card_data.residual_climate_value_at_risk || 0);

  const cards = [
    {
      title: "Climate Value at Risk",
      value: climate_risk_card_data.climate_value_at_risk,
      color: "#EDF4FF",
      icon: (
        <Icon
          name="info"
          onClick={handleCardFindings_3}
          style={{ cursor: "pointer" }}
        />
      ),
    },
    {
      title: "Residual Climate Value at Risk",
      value: climate_risk_card_data.residual_climate_value_at_risk,
      color: "#EDF4FF",
      icon: (
        <Icon
          name="info"
          onClick={handleCardFindings_6}
          style={{ cursor: "pointer" }}
        />
      ),
    },
    {
      title: "Avoided Loss",
      value: avoidedLoss,
      color: "#EDF4FF",
      icon: null,
    },
    {
      title: "Maximum Exposure",
      value: climate_risk_card_data.max_exposure,
      color: "#EDF4FF",
      icon: (
        <Icon
          name="info"
          onClick={handleCardFindings_1}
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <div
      style={{
        margin: "20px 0",
        background: "white",
        borderRadius: "10px",
        padding: "10px 15px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Row>
        {cards.map((card, idx) => (
          <Col lg={3} md={6} sm={12} key={idx}>
            <div
              style={{
                background: "#EDF4FF",
                padding: "20px",
                borderRadius: "10px",
                textAlign: "center",
              }}
            >
              <h2 style={{ fontSize: "2rem", marginBottom: 0 }}>
                {formatAmount(card.value)}
              </h2>
              <p className="mb-1 fw-bold">
                {card.title} {card.icon}
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ClimateRiskKPICards;
